<template>
  <div
    v-if="show"
    class="houseKey-container"
    :data-error="checkBoxError"
    :data-skip="true"
  >
    <Message :text="error" severity="warning" />
    <checkbox
      class="houseKey-checkbox"
      :required="show"
      :name="name"
      :text="name"
      :value="false"
      :errors="errors"
      @input="val => (inputValue = val ? name : null)"
    ></checkbox>
  </div>
</template>

<script>
import Message from '@/components/Message'

export default {
  name: 'HouseKeyError',
  components: {
    Checkbox: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/Checkbox'
      )
    },
    Message,
  },
  data: () => ({
    error: '',
    checkBoxError: '',
    show: false,
    required: false,
    inputValue: null,
    name: '',
    errors: {},
  }),
  created() {
    window.addEventListener('house-key-error', data => {
      const { show, error, name, checkBoxError } = data.detail
      this.show = show
      this.required = show
      this.error = error
      this.checkBoxError = checkBoxError
      this.name = name
      this.errors = {}
    })
  },
}
</script>

<style lang="postcss" scoped>
.houseKey {
  &-checkbox {
    margin-top: 20px;
    margin-bottom: 35px;
  }
}
</style>
